import { useLocation } from 'wouter';
import { useCallback, useRef } from 'react';
import { navLog } from './debug';

export function useNav() {
  const [location, setLocation] = useLocation();
  const busy = useRef(false);

  const go = useCallback((to: string) => {
    if (!to) return;
    if (busy.current) return;
    if (to === location) return;
    busy.current = true;
    queueMicrotask(() => {
      try {
        navLog('go', { from: location, to });
        setLocation(to);
      } finally {
        busy.current = false;
      }
    });
  }, [location, setLocation]);

  return { location, go } as const;
}

export default useNav;


